import React, {useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// context
import {FavouritesContext} from "../../context/FavouritesContext"
// styling and icons
import "./FavouriteToggle2.scss";
import {faHeart as faHeartSolid} from "@fortawesome/free-solid-svg-icons";
import {faHeart as faHeartOutline} from "@fortawesome/free-regular-svg-icons";


// the component
function FavouriteToggle({activityId, className}) {
  // context
  const Favourites = useContext(FavouritesContext);

  let isFavourite = Favourites.isFavourite(activityId);

  const onClick = () => {
    isFavourite ? Favourites.remove(activityId) : Favourites.add(activityId);
  }

  // render
  return (
    <div className={`c-favourite-toggle2 ${className}`} onClick={onClick}>
      <FontAwesomeIcon icon={isFavourite ? faHeartSolid : faHeartOutline} />
    </div>
  )
}

export default FavouriteToggle